import { render, staticRenderFns } from "./printCFPurReturn.vue?vue&type=template&id=3c4d205c&scoped=true&"
import script from "./printCFPurReturn.vue?vue&type=script&lang=js&"
export * from "./printCFPurReturn.vue?vue&type=script&lang=js&"
import style0 from "./printCFPurReturn.vue?vue&type=style&index=0&id=3c4d205c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4d205c",
  null
  
)

component.options.__file = "printCFPurReturn.vue"
export default component.exports